import React, { ReactElement } from "react";
import MainImg from "./mainImg";

export default function CarWarranty(): ReactElement {
    return (
        <section className="flex flex-col lg:flex-row lg:gap-28 gap-16  lg:py-8 py-4 lg:px-12 px-6 lg:mt-52 mt-20 bg-[#F1F6FF] relative">
            <div className="max-w-[500px]  mx-auto lg:mx-0 ">
                <h2 className="font-bold lg:text-3xl text-2xl lg:leading-[45px] ">
                    Car Warranty?
                </h2>
                <p className="mt-3    text-base lg:leading-8  font-light">
                    A car warranty gives you protection against having to pay
                    for labour costs and replacement of certain parts of your
                    vehicle if they suffer from mechanical faults or electrical
                    failure. Often it can be very expensive to repair your
                    vehicle. It's important to check how to keep your warranty
                    valid.
                </p>
            </div>
            <div className="w-[300px] h-[250px] md:h-[315px] md:w-[330px] md:min-w-[330px] lg:absolute relative mx-auto lg:mx-0 lg:bottom-8 lg:right-24 ">
                <MainImg />
            </div>
        </section>
    );
}
